import { PCFSoftShadowMap, WebGLRenderer } from "three";
class RendererManager {
    renderer;
    static instance;
    /**
     * RendererManager manages the Renderer object.
     * @private
     */
    constructor() {
        this.renderer = this.buildRenderer();
        this.updateResolution();
    }
    /**
     * Render the scene.
     * @param scene the rendering scene.
     * @param camera The used camera object.
     */
    step(scene, camera) {
        this.renderer.render(scene, camera.getCamera);
    }
    /**
     * Update the renderer's resolution to match the viewport.
     */
    updateResolution() {
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
    /**
     * Create and configure a WebGLRenderer object.
     * @returns the created WebGL renderer object.
     * @private
     */
    buildRenderer() {
        const renderer = new WebGLRenderer({ antialias: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = PCFSoftShadowMap;
        renderer.sortObjects = false;
        document.body.appendChild(renderer.domElement);
        return renderer;
    }
    static getInstance() {
        if (!RendererManager.instance)
            RendererManager.instance = new RendererManager();
        return RendererManager.instance;
    }
}
export default RendererManager;
